import React, { useState } from "react";
import styled, { css } from "styled-components";
import { TaskStatus } from "@lifeat/shared/task-management/TaskStatus";
import LifeAtCheckbox from "@common/LifeAtCheckbox/LifeAtCheckbox";
import Styles from "@themes/Styles";

/* ------------------------------------------------------------- */
/* -------------------- Task item wrapper ---------------------- */
/* ------------------------------------------------------------- */
export const TaskItemContainer = styled.div<{ isTouchDevice: boolean; ribbonColor?: string }>`
    display: flex;
    padding: 10px;
    background-color: ${(props) => props.theme.backgroundPrimary};
    outline: 1px solid ${(props) => props.theme.borderPrimary};
    border-radius: ${Styles.borderRadiusSharp};
    border-left: 7px solid ${(props) => props.ribbonColor ?? "transparent"};
    cursor: pointer;
    &:hover {
        outline: 1px solid ${Styles.lifeatSpecialBlue};
    }

    margin: 0 9px 0 20px;

    ${(props) =>
        props.isTouchDevice &&
        css`
            &:hover {
                border: 2px solid ${Styles.lifeatSpecialBlue};
                background-color: ${(props) => props.theme.backgroundSpecial};
            }
        `};

    // This removed the square corners on the element when dragging
    // ref: https://github.com/react-dnd/react-dnd/issues/788
    transform: translate(0, 0);
`;
/* ------------------------------------------------------------- */
/* -------------------- Task title wrapper --------------------- */
/* ------------------------------------------------------------- */
export const TaskTitleWrapper = styled.div<{ isCompleted: boolean }>`
    width: 100%;
    ${(props) =>
        props.isCompleted &&
        css`
            text-decoration: line-through;
            color: ${props.theme.textColorSecondary};
        `};
    * > * {
        padding: unset;
        ${(props) =>
            props.isCompleted &&
            css`
                color: ${props.theme.textColorSecondary};
            `};
    }
`;

/* ------------------------------------------------------------- */
/* -------------------- Task status checkbox ------------------- */
/* ------------------------------------------------------------- */
const StyledLifeAtCheckbox = styled(LifeAtCheckbox)`
    margin-top: 1px;
`;

interface TaskStatusCheckboxProps {
    readonly updateTaskStatus: (status: TaskStatus) => Promise<void>;
    readonly onComplete: () => void;
    readonly isTaskCompleted: boolean;
    readonly isDisabled?: boolean;
}
export function TaskStatusCheckbox(props: TaskStatusCheckboxProps) {
    const [isTaskCompleted, setIsTaskCompleted] = useState(props.isTaskCompleted);

    const toggleStatus = (e?: React.MouseEvent | React.ChangeEvent) => {
        e?.stopPropagation();
        const updatedStatus = !isTaskCompleted;
        setIsTaskCompleted(updatedStatus);
        props.updateTaskStatus(updatedStatus ? "COMPLETE" : "OPEN");
        props.onComplete();
    };

    return (
        <StyledLifeAtCheckbox checked={isTaskCompleted} handleToggle={toggleStatus} isDisabled={!!props.isDisabled} />
    );
}

/* ------------------------------------------------------------- */
/* ----------------- Task title input wrapper ------------------ */
/* ------------------------------------------------------------- */
export const StyledTaskTitleWrapper = styled(TaskTitleWrapper)`
    cursor: text;
    width: 100%;

    border-radius: 3px;
    padding: 0 4px;

    * > * {
        ::-webkit-scrollbar-thumb {
            display: none;
        }
        background-color: unset;
    }

    &:hover {
        background-color: ${(props) => props.theme.backgroundSpecial};
    }
`;
